/** Module whose clusters a Cluster Manager works with (same values as the API). */
export type ClusterModule = 'brand' | 'nonbrand';

/** Aggregated country tab, and region of a global assignment ('ALL' in the API too). */
export const ALL_REGIONS = 'ALL';

export type MetricFormat = 'number' | 'currency' | 'percent';

export interface ClusterMetricColumn {
  field: string;
  headerName: string;
  format: MetricFormat;
  barColor: string;
  /** Width reserved for the value so the bars line up across rows. */
  valueMinWidth: number;
}

export interface ClusterManagerConfig {
  module: ClusterModule;
  /** When true, assignments belong to the tab's region; otherwise they are always global. */
  regionScoped: boolean;
  /**
   * Brand publishes the full country list to the global country filter on first load
   * (legacy behaviour kept as is). Non Brand must not: its Overview tab reads
   * filterStore.countries[0] as its selected region.
   */
  publishesCountryFilter: boolean;
  metricColumns: ClusterMetricColumn[];
  defaultSortField: string;
}

const AD_COST: ClusterMetricColumn = {
  field: 'ad_cost',
  headerName: 'Ad Cost',
  format: 'currency',
  barColor: '#DAA335',
  valueMinWidth: 65,
};

const BLENDED_CTR: ClusterMetricColumn = {
  field: 'blended_ctr',
  headerName: 'Blended CTR',
  format: 'percent',
  barColor: '#5119B7',
  valueMinWidth: 50,
};

export const BRAND_CLUSTER_CONFIG: ClusterManagerConfig = {
  module: 'brand',
  regionScoped: false,
  publishesCountryFilter: true,
  metricColumns: [
    { field: 'brand_searches', headerName: 'Brand Searches', format: 'number', barColor: '#EE7A63', valueMinWidth: 45 },
    AD_COST,
    BLENDED_CTR,
  ],
  defaultSortField: 'brand_searches',
};

export const NONBRAND_CLUSTER_CONFIG: ClusterManagerConfig = {
  module: 'nonbrand',
  regionScoped: true,
  publishesCountryFilter: false,
  metricColumns: [
    { field: 'nonbrand_traffic', headerName: 'Non Brand Traffic', format: 'number', barColor: '#EE7A63', valueMinWidth: 45 },
    AD_COST,
    BLENDED_CTR,
  ],
  defaultSortField: 'nonbrand_traffic',
};

/** Non Brand pages work with Non Brand clusters, every other page with Brand ones. */
export const clusterModuleForPath = (pathname: string): ClusterModule =>
  pathname.startsWith('/non-brand/') ? 'nonbrand' : 'brand';
